import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    precision: Number,
    fixed: Boolean
  }

  hidden_field = null;
  re = null;

  connect() {
    if (this.precisionValue == "0") {
      this.re = new RegExp("^\\d*$")
    } else {
      this.re = new RegExp("^\\d*,?\\d{0," + this.precisionValue + "}$")
    }
    this.hidden_field = document.createElement("input");
    this.hidden_field.type = "hidden";
    this.hidden_field.name = this.element.name;
    this.hidden_field.value = this.element.value;
    this.element.after(this.hidden_field);
    if (this.precisionValue > 0 && !isNaN(parseFloat(this.element.value))) {
      if (this.fixedValue) {
        this.element.value = parseFloat(this.element.value).toFixed(this.precisionValue);
      } else {
        this.element.value = parseFloat(this.element.value).toString();
      }
    }
    this.element.value = this.element.value.replace(".", ",");
    this.element.defaultValue = this.element.value; // to fix wrong value issue after form reset
    this.element.setAttribute("data-name", this.element.name);
    this.element.name = "";

    this.element.addEventListener("keydown", (event) => this.input(event));
    this.element.addEventListener("keyup",   (event) => this.update(event));
  }

  update(event) {
    // check for invalid pasted value?
    event.target.value = event.target.value.trim();
    if (!this.is_valid(event.target.value)) {
      event.target.value = this.hidden_field.value.replace(".", ",");
    }
    this.hidden_field.value = event.target.value.replace(",", ".");
  }

  input(event) {
    if (event.ctrlKey) return; // pass ctrl modifier
    if (event.key.length > 1) return; // other special keys (up, down, etc.)

    let value = event.target.value;
    let position = event.target.selectionStart;
    let new_value = value.substring(0, position) + event.key + value.substring(position);
    if (!this.is_valid(new_value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  // private
  is_valid(value) {
    if (value.length == 0) return true;
    return value.match(this.re);
  }

}
